module.exports = __webpack_public_path__ + "img/404.419a2384.svg";